export const AI_QA_ROUTER_BASE = '/dashboard-controls/ai-qa';
